export class AddOnsHelper {
    static Icons = {
        "upload": "icon-upload"
    };

    static getIcon(icon) {
        const output = this.Icons[icon];
        if(undefined === output) {
            return "icon-box";
        }

        return output;
    }
}
